module.exports = __webpack_public_path__ + "img/71623B_ECDE8C_30250A_ABA69A-256px.4ce1f89c.png";